import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const UTILITY_POLES = {
  YES: 'yes',
  NO: 'no',
  IDK: 'does_not_know',
} as const;

export const UTILITY_POLES_NAME = 'utility_poles';

interface Props {
  name?: string;
}

export const RadioGroupUtilityPoles: FC<Props> = ({
  name = UTILITY_POLES_NAME,
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy na działce są słupy energetyczne?')}
          </FormLabel>
          <FormControl>
            <RadioGroup {...field} layout={'horizontal'}>
              <RadioItem
                data-testid={`${name}-radio-group-${UTILITY_POLES.YES}`}
                value={UTILITY_POLES.YES}
                label={i18n.t('Tak')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${UTILITY_POLES.NO}`}
                value={UTILITY_POLES.NO}
                label={i18n.t('Nie')}
              />
              <RadioItem
                data-testid={`${name}-radio-group-${UTILITY_POLES.IDK}`}
                value={UTILITY_POLES.IDK}
                label={i18n.t('Nie wiem')}
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
